import { CommonService } from '@/services/Common.service';
import { AuthenService } from '@/services/authen.service';

export class FeeService {
  private baseAPI = process.env.VUE_APP_API_URL;
  private authService = new AuthenService();
  private commonService = new CommonService();

  constructor() {
  }

  get headers() {
    return {
      'Content-Type': 'application/json',
      'auth': localStorage.getItem('token'),
    };
  }

  async getFeeTable(versionId: number) {
    const path  = `/fee-table-manage/${versionId}`;
    const { result, error } = await this.commonService.get(`${this.baseAPI}${path}`);
    if (result && result.status === 200) {
      return result.data;
    } else {
      this.authService.handleError(error, 'getFeeTable');
      return [];
    }
  }

  async addFee(versionId: number, data: any) {
    const path  = `/fee-table-manage/${versionId}`;
    const { result, error } = await this.commonService.post(`${this.baseAPI}${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'addFee');
      return;
    }
  }

  async updateFee(data: any) {
    const path  = "/fee-table-manage";
    const { result, error } = await this.commonService.put(`${this.baseAPI}${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'updateFee');
      return;
    }
  }

  async updateFeeOrder(data: any) {
    const path  = "/fee-table-manage-display-order";
    const { result, error } = await this.commonService.put(`${this.baseAPI}${path}`, data);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'updateFeeOrder');
      return;
    }
  }

  async deleteFee(id: number) {
    const path  = `/fee-table-manage/${id}`;
    const { result, error } = await this.commonService.delete(`${this.baseAPI}${path}`);
    if (result) {
      return result.status;
    } else {
      this.authService.handleError(error, 'deleteFee');
      return;
    }
  }
}
